import React, { FC } from 'react';

import { ReactComponent as ChevronRight } from 'assets/icons/ChevronRight.svg';

import { ChannelCustomFeedSchema, ChannelSectionListV2 } from 'constants/graphqlTypes';

import UILink from 'components/UI/Link';
import FeedCarousel from 'components/CustomFeeds/FeedCarousel';
import AddCustomFeedCard from 'components/CustomFeeds/FeedCard/AddCustomFeedCard';

import { useGetChannelSectionItems } from 'graphQL/channel/hooks';
import useTheme from 'helpers/useTheme';
import { ROUTE_CUSTOM_FEEDS } from 'routes';

import { StyledFeedCardWrap } from 'components/CustomFeeds/FeedCard/styled';
import { StyledSectionType, StyledSectionWrap, StyledSvgContainer, StyledTextContainer, StyledTitle } from '../styled';

interface ICustomFeedSectionProps {
  section: ChannelSectionListV2;
  feedDescription?: string;
}

const CustomFeedSection: FC<ICustomFeedSectionProps> = ({ section: { id, title }, feedDescription }) => {
  const isDark = useTheme();
  const { items, totalCount, loadMore } = useGetChannelSectionItems(id);

  const customFeeds: ChannelCustomFeedSchema[] =
    items?.reduce((prev: ChannelCustomFeedSchema[], curr) => {
      if (curr && curr.__typename === 'ChannelCustomFeedSchema') {
        prev.push(curr);
      }
      return prev;
    }, []) ?? [];
  const isNotCustomFeeds = !customFeeds?.length;

  return (
    <StyledSectionWrap>
      <StyledTextContainer>
        <StyledTitle isDark={isDark}>
          <UILink route={ROUTE_CUSTOM_FEEDS} isDisabled={isNotCustomFeeds}>
            <span>{title ?? ''}</span>
            {!isNotCustomFeeds && (
              <StyledSvgContainer isDark={isDark}>
                <ChevronRight />
              </StyledSvgContainer>
            )}
          </UILink>
        </StyledTitle>
        {isNotCustomFeeds && <StyledSectionType>{feedDescription ?? ''}</StyledSectionType>}
      </StyledTextContainer>
      {!isNotCustomFeeds ? (
        <FeedCarousel totalCount={totalCount ?? 0} loadMore={loadMore} customFeeds={customFeeds} />
      ) : (
        <StyledFeedCardWrap>
          <AddCustomFeedCard sectionId={id} />
        </StyledFeedCardWrap>
      )}
    </StyledSectionWrap>
  );
};

export default CustomFeedSection;
